import { render, staticRenderFns } from "./SingleSiteComparisonTable.vue?vue&type=template&id=28c2b5e2"
import script from "./SingleSiteComparisonTable.vue?vue&type=script&lang=ts"
export * from "./SingleSiteComparisonTable.vue?vue&type=script&lang=ts"
import style0 from "./SingleSiteComparisonTable.vue?vue&type=style&index=0&id=28c2b5e2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports